import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement } from 'chart.js';
import { Routes, useNavigate } from 'react-router-dom';
import './hrdashboard.css';
import { Route } from 'react-router-dom';
import LeaveManagement from './Leavemanagement';
import Policies from './Policies';
import Announcement from './Announcements';
import EmployeeProfile from './Employeeprofile';

// Register necessary Chart.js components
ChartJS.register(Title, Tooltip, Legend, ArcElement);

const HrDashboard = () => {
  const [hrPieData, setHrPieData] = useState({
    labels: ['Leaves', 'Action required termination', 'Attendance Vs Productivity'],
    datasets: [
      {
        data: [0, 0, 0],
        backgroundColor: ['#D0A6C4', '#A2D2FF', '#FAD02E'],
      },
    ],
  });

  const [empId, setEmpId] = useState('');
  const [empName, setEmpName] = useState('');
  const [designation, setDesignation] = useState('');

  const navigate = useNavigate(); // For navigation after logout

  const pieOptions = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.label || '';
            let value = context.raw;
            let total = context.dataset.data.reduce((acc, val) => acc + val, 0);
            let percentage = ((value / total) * 100).toFixed(2);
            label += `: ${percentage}%`;
            return label;
          },
        },
      },
    },
  };

  const fetchHRData = async () => {
    try {
      const leaveResponse = await axios.get('https://cleezoclass.com:8443/api/total-leaves');
      const terminationResponse = await axios.get('https://cleezoclass.com:8443/api/termination-required');
      const productivityResponse = await axios.get('https://cleezoclass.com:8443/api/total-productivity');

      const { approved, pending, rejected } = leaveResponse.data.data;
      const terminationRequired = parseInt(terminationResponse.data.data.terminationRequired, 10) || 0;
      const totalProductivity = Number(productivityResponse.data.data.totalProductivity);

      const totalLeaves = Number(approved) + Number(pending) + Number(rejected);

      // Update HR pie chart data
      setHrPieData({
        labels: ['Leaves', 'Termination Required', 'Productivity'],
        datasets: [
          {
            data: [totalLeaves, terminationRequired, totalProductivity],
            backgroundColor: [
              totalLeaves > 50 ? '#FF6347' : '#4CAF50',
              terminationRequired > 10 ? '#FF6347' : '#FF9800',
              totalProductivity > 70 ? '#4CAF50' : '#FF9800',
            ],
          },
        ],
      });
    } catch (error) {
      console.error('Error fetching HR data:', error);
    }
  };

  useEffect(() => {
    // Load employee details from localStorage
    const storedEmpId = localStorage.getItem('empId');
    const storedEmpName = localStorage.getItem('empName');
    const storedDesignation = localStorage.getItem('designation');

    // Check if employee details exist in localStorage
    if (!storedEmpId || !storedEmpName || !storedDesignation) {
      alert('Session expired. Please log in again.');
      navigate('/'); // Navigate to the homepage or login page
    } else {
      setEmpId(storedEmpId);
      setEmpName(storedEmpName);
      setDesignation(storedDesignation);
      // Fetch HR data after loading employee details
      fetchHRData();
    }
  }, [navigate]); // Re-run the effect if navigate changes (if needed)

  // Logout function
  const handleLogout = () => {
    localStorage.removeItem('empId');
    localStorage.removeItem('empName');
    localStorage.removeItem('designation');
    navigate('/'); // Redirect to homepage after logout
  };

  return (
    <div className="hr-dashboard-container mainBlock">
      {/* Header */}

      {/* Employee Details Section */}
      {/* <section className="hr-dashboard-employee-details">
        <p><strong>Employee ID:</strong> {empId || "Not Available"}</p>
        <p><strong>Name:</strong> {empName || "Name not available"}</p>
        <p><strong>Designation:</strong> {designation || "Designation not available"}</p> */}
      {/* Logout Button */}
      {/* <button onClick={handleLogout} className="hr-dashboard-logout-btn-custom">
          Logout
        </button>
      </section> */}

      {/* HR Data Section */}
      <section className="hr-dashboard-section ">
        <h2 className="hr-dashboard-section-title">HR & Admin Management</h2>
        <div className="hr-dashboard-chart-container">
          <Pie data={hrPieData} options={pieOptions} width={400} height={400} />
        </div>

        {/* Links Section - Contained inside the section box */}
        {/* <div className="hr-dashboard-links-container">
    <div><Link to="/Leavemanagement" className="hr-dashboard-link">Leave Management</Link></div>
    <div><Link to="/Policies" className="hr-dashboard-link">Policies</Link></div>
    <div><Link to="/Announcements" className="hr-dashboard-link">Announcements</Link></div>
    <div><Link to="/Employeeprofile" className="hr-dashboard-link">Employee Profile</Link></div>
  </div> */}
        <Routes>
          <Route path="/Leavemanagement" element={<LeaveManagement />} />
          <Route path="/Policies" element={<Policies />} />
          <Route path="/Announcements" element={<Announcement />} />
          <Route path="/Employeeprofile" element={<EmployeeProfile />} />

        </Routes>

      </section>

    </div>
  );
};

export default HrDashboard;
